import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12 md:col-3 lg:col-2 p-fluid" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "col-12 md:col-3 lg:col-2 p-fluid" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "col-12 md:col-3 lg:col-2 p-fluid" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = { class: "col-fixed" }
const _hoisted_9 = { class: "grid" }
const _hoisted_10 = { class: "col-12 md:col-6 lg:col-4" }
const _hoisted_11 = { class: "col-12 md:col-6 lg:col-4" }
const _hoisted_12 = { class: "col-12 md:col-6 lg:col-4" }
const _hoisted_13 = { class: "col-12 md:col-6 lg:col-4" }
const _hoisted_14 = { class: "col-12 md:col-6 lg:col-4" }
const _hoisted_15 = { class: "col-12 md:col-6 lg:col-4" }
const _hoisted_16 = { class: "col-12 md:col-6 lg:col-4" }
const _hoisted_17 = { class: "col-12 md:col-6 lg:col-4" }
const _hoisted_18 = { class: "grid" }
const _hoisted_19 = { class: "col-12 lg:col-6" }
const _hoisted_20 = { class: "col-12 lg:col-6" }
const _hoisted_21 = { class: "col-12 lg:col-6" }
const _hoisted_22 = { class: "col-12 lg:col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PerformanceChart1 = _resolveComponent("PerformanceChart1")!
  const _component_PerformanceChart2 = _resolveComponent("PerformanceChart2")!
  const _component_PerformanceChart3 = _resolveComponent("PerformanceChart3")!
  const _component_PerformanceChart4 = _resolveComponent("PerformanceChart4")!
  const _component_PerformanceChart5 = _resolveComponent("PerformanceChart5")!
  const _component_PerformanceChart6 = _resolveComponent("PerformanceChart6")!
  const _component_PerformanceChart7 = _resolveComponent("PerformanceChart7")!
  const _component_PerformanceChart8 = _resolveComponent("PerformanceChart8")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_PerformanceChartWh1 = _resolveComponent("PerformanceChartWh1")!
  const _component_PerformanceChartWh2 = _resolveComponent("PerformanceChartWh2")!
  const _component_PerformanceChartWh3 = _resolveComponent("PerformanceChartWh3")!
  const _component_PerformanceChartWh4 = _resolveComponent("PerformanceChartWh4")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "m-2" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_Dropdown, {
              id: "calendar",
              modelValue: _ctx.selectedYear,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
              options: _ctx.years,
              onChange: _ctx.onSearch
            }, null, 8, ["modelValue", "options", "onChange"]),
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "calendar" }, "ระบุปีที่ต้องการดูรายงาน", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_MultiSelect, {
              id: "monthSelect",
              modelValue: _ctx.selectedMonths,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedMonths) = $event)),
              options: _ctx.months
            }, null, 8, ["modelValue", "options"]),
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "monthSelect" }, "ระบุเดือน", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_MultiSelect, {
              id: "office",
              modelValue: _ctx.selectedOffices,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedOffices) = $event)),
              options: _ctx.offices,
              optionLabel: "description",
              optionValue: "code"
            }, null, 8, ["modelValue", "options"]),
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "office" }, "สาขา", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            icon: "pi pi-download",
            onClick: _ctx.onDownload,
            loading: _ctx.isLoading,
            label: "Download Excel",
            class: "p-button-success"
          }, null, 8, ["onClick", "loading"])
        ])
      ]),
      _createVNode(_component_TabView, {
        activeIndex: _ctx.selectedTab,
        "onUpdate:activeIndex": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, { header: "รายงานตามเดือน" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_PerformanceChart1, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_PerformanceChart2, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_PerformanceChart3, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_PerformanceChart4, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_PerformanceChart5, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_PerformanceChart6, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_PerformanceChart7, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_PerformanceChart8, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, { header: "รายงานตาม Warehouse" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_PerformanceChartWh1, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_PerformanceChartWh2, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_PerformanceChartWh3, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_PerformanceChartWh4, { summary: _ctx.filteredSummary }, null, 8, ["summary"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ]),
    _: 1
  }))
}